import React from "react";

export const Endometriosis01: React.FC = () => {
  return (
    <div className="endo01-section">
      <div className="endo01-container">
        <div className="endo01-content">
          <div className="endo01-left">
            <h2 className="endo01-title">¿Qué es la Endo?</h2>
            
            <p className="endo01-quote">
              <em>
                "La endometriosis es una enfermedad inflamatoria sistémica caracterizada por la presencia
                de tejido similar al endometrial en zonas extrauterinas". <strong>(Kennedy S. et al., 2005; Klemmt et al., 2018; Saunders et al., 2021)</strong>
              </em>
            </p>
            
            <p className="endo01-text">
              Es una enfermedad que al día de hoy no tiene cura por lo que es denominada <span className="endo01-highlight">crónica</span>.
              A su vez, se considera <span className="endo01-highlight">sistémica</span> porque se ha encontrado en absolutamente todos los
              órganos del cuerpo y es capaz de alterar muchas funciones en nuestro organismo.
            </p>
            
            <p className="endo01-text">
              De acuerdo a las estadísticas actuales, afecta a <span className="endo01-highlight">AL MENOS</span> una de cada diez personas
              asignadas como mujeres al nacer. Sin embargo hay que tener en cuenta que es una patología que se ha
              encontrado en hombres cisgénero (nacidos e identificados como hombres), fetos, personas post
              histerectomía (sin útero), en menopausia y animales que no menstrúan por lo que <em>definirla como una
              enfermedad ginecológica es, a nuestro entender, uno de los mayores errores que comete la comunidad
              médica.</em>
            </p>
          </div>
          
          <div className="endo01-right">
            <h2 className="endo01-title endo01-title-hidden" aria-hidden="true">¿Qué es la Endo?</h2>
            
            <p className="endo01-text">
              También es necesario tener una visión que vaya más allá del género e incluir a todas las personas,
              muchas de las cuales a menudo luchan por acceder al diagnóstico, tratamiento y atención de apoyo y
              calidad de la endometriosis en un espacio tradicionalmente identificado como "femenino". Por ejemplo,
              es importante reconocer que, aunque la enfermedad se asocia tradicionalmente a las mujeres cisgénero
              (nacidas e identificadas como mujeres), la endometriosis también debe reconocerse como un problema
              importante para las identidades trans.
            </p>
            
            <div className="moreinfo-image-container">
              <img
                src="img/reading.png"
                className="moreinfo-image"
                alt="Books about endometriosis"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};